// useHeaderHeight.js
import { useEffect } from 'react';

const useHeaderHeight = () => {
  useEffect(() => {
    const updateHeaderHeight = () => {
      // Employee pages render no site chrome; their in-page <header> elements
      // (hero cards) must not drive the layout offset — and a stale value from
      // an admin/public page would push content down by a full header height.
      if (window.location.pathname.startsWith('/employee')) {
        document.documentElement.style.setProperty('--header-height', '0px');
        return;
      }
      const header = document.querySelector('header');
      if (header) {
        document.documentElement.style.setProperty(
          '--header-height',
          `${header.offsetHeight}px`
        );
      }
    };

    updateHeaderHeight();
    window.addEventListener('resize', updateHeaderHeight);
    return () => window.removeEventListener('resize', updateHeaderHeight);
  }, []);
};

export default useHeaderHeight;
